function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M26.336 7.6h23.117M15.387 61.6h-4.87C5.822 61.6 2 57.831 2 53.2M22.002 61.6H19.57",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.421 55.6H10.517c-2.016 0-3.646-1.611-3.646-3.6V11.2c0-1.988 1.634-3.6 3.65-3.6h7.3",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M57.97 7.6h3.65c2.016 0 3.65 1.612 3.65 3.6V52",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.038 4h2.433c.671 0 1.216.538 1.216 1.2v9.6c0 .662-.545 1.2-1.216 1.2h-2.433a1.209 1.209 0 01-1.217-1.2V5.2c0-.662.545-1.2 1.216-1.2zM50.67 4h2.433c.672 0 1.217.538 1.217 1.2v9.6c0 .662-.545 1.2-1.217 1.2H50.67a1.209 1.209 0 01-1.217-1.2V5.2c0-.662.545-1.2 1.217-1.2zM6.87 24.4h58.4",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.387 31.6h9.733M31.203 31.6h9.734M47.019 31.6h9.733M15.387 40h9.733M15.387 48.4h9.733",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M50.67 37.6c-2.405 0-4.668.583-6.667 1.6l-3.836-1.51a1.209 1.209 0 00-1.664 1.11c0 .078.024.236.024.236l.793 3.914A14.214 14.214 0 0036.07 52c0 7.953 6.536 14.4 14.6 14.4 8.062 0 14.6-6.448 14.6-14.4s-6.538-14.4-14.6-14.4v0z",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M56.753 46c0 3.314-2.724 6-6.083 6-3.36 0-6.084-2.686-6.084-6v-1.2h12.167V46zM44.586 58c0-3.313 2.724-6 6.084-6 3.359 0 6.083 2.687 6.083 6v1.2H44.586V58z",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M69.509 57.044c-1.28 4.903-4.46 8.805-8.736 11.37M70.137 51.2c0 .62-.03 1.233-.088 1.838",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgComplexCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default __webpack_public_path__ + "/img/complex-calendar.svg";
export { SvgComplexCalendar as ReactComponent };